import styled from 'styled-components';
import { PromoIdentifier } from '@tvg/fuse-design';

const StyledPromoIdentifier = styled(PromoIdentifier)`
  margin-bottom: var(--spacing-space16);
`;

export default StyledPromoIdentifier;
